<template>
  <form @submit.prevent="submit()">
    <template v-for="input in inputs">
      <component
        :key="input.key"
        :is="input.component"
        :config="input"
        v-model="$data[input.key]">
      </component>
    </template>
    <v-card-row actions>
      <v-btn
        type="submit"
        primary light ripple
        :loading="loading">
        {{ $t('accounts.informations.save') }}
      </v-btn>
    </v-card-row>
  </form>
</template>

<script>
  import currentExpert from '@/mixins/currentExpert'
  import { TextInput, DateInput, PhoneInput } from '@/components/inputs'
  export default {
    mixins: [currentExpert],
    data () {
      return {
        error: {},
        email: this.expert.email,
        first_name: this.expert.first_name,
        last_name: this.expert.last_name,
        birthday: new Date(this.expert.birthday),
        phone: this.expert.phone
      }
    },
    computed: {
      inputs () {
        return [
          { key: 'email', type: 'email', component: TextInput }, { key: 'first_name', component: TextInput },
          { key: 'last_name', component: TextInput }, { key: 'birthday', component: DateInput },
          { key: 'phone', component: PhoneInput }
        ]
          .map(input => ({
            ...input,
            required: true,
            label: this.$t(`accounts.informations.labels.${input.key}`),
            errors: (this.error[input.key] || []).map(e => () => e)
          }))
      }
    },
    methods: {
      submit () {
        this.save({ data: {
          ...this.$data
        } })
          .catch(({ response }) => (this.error = (response || {}).data || {}))
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/account/Informations.vue